import { render, staticRenderFns } from "./ComponentList.vue?vue&type=template&id=5d274d79&scoped=true&"
import script from "./ComponentList.vue?vue&type=script&lang=js&"
export * from "./ComponentList.vue?vue&type=script&lang=js&"
import style0 from "./ComponentList.vue?vue&type=style&index=0&id=5d274d79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d274d79",
  null
  
)

export default component.exports